export default "__VITE_ASSET__jApmYO8B__"